import { useCallback } from 'react';

// @ts-expect-error - useInformationPopup does not have a type definition
import { useInformationPopup } from 'src/components/PopupInformation';

export const useUnsupportedPromptPopup = () => {
  const infoPopup = useInformationPopup();

  return useCallback(
    () =>
      infoPopup({
        title: 'This prompt is not supported',
        content:
          'The general prompt window only supports text and/or image generation.\nPlease update your input so we can generate content for you.',
        dataTestId: 'unsupportedPrompt',
        buttons: { submitLabel: 'Update' },
      }),
    [infoPopup]
  );
};
